// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2_ggx","box":"WorkspacesBox_box__3t7Ns","node":"WorkspacesBox_node__3_sv_"};